export const endpoints = {
  users: '/users',
  user: '/users/{id}',
  currentUser: '/users/me',
  currentUserMeetingUrl: '/users/me/meeting-url',
  inviteUser: '/users/invite',
  workspaceUsers: '/users/workspace',
  availabilityPreferences: '/users/{id}/availability-preferences',
} as const;
